.explainer {
    max-width: 250px;
}

.icon {
    padding: 2px;
}